import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TitheReceiptDataTable from '../components/TitheReceipts/TitheReceiptDataTable';
import TitheReceiptForm from '../components/TitheReceipts/TitheReceiptForm';
import { requireTitheAccess } from '../components/common/SecureAdminPage';

const TitheReceipts = () => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const [showCreateForm, setShowCreateForm] = useState(false);

  const handleCreateSuccess = () => {
    // Refresh the data table
    setShowCreateForm(false);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="py-6">
        <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
          {/* Security Notice */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
            <div className="flex items-center">
              <svg className="w-5 h-5 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-green-800 text-sm font-medium">
                {t('titheReceipts.secureNotice')}
              </span>
            </div>
          </div>

          {/* Header */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">{t('titheReceipts.headerTitle')}</h1>
              <p className="text-gray-600 mt-1">
                {t('titheReceipts.headerSubtitle')}
              </p>
            </div>
            
            <button
              onClick={() => setShowCreateForm(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span>{t('titheReceipts.createNew')}</span>
            </button>
          </div>

          {/* Data Table */}
          <TitheReceiptDataTable />

          {/* Create Form Modal */}
          {showCreateForm && (
            <TitheReceiptForm
              onClose={() => setShowCreateForm(false)}
              onSuccess={handleCreateSuccess}
            />
          )}
        </div>
      </div>
    </div>
  );
};

// Export with security wrapper
// TEMPORARILY DISABLED FOR DEBUGGING
export default TitheReceipts;
// export default requireTitheAccess(TitheReceipts);
